import { DataTable } from '@components/Table/DataTable';
import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { IRemessa } from '@model/Remessa';
import { IRemessaFilter } from '@services/RemessaService';
import React from 'react';
import { RemessaDetalheModal } from './RemessaDetalheModal';

export type RemessaTableProps = {
    isLoading: boolean
    data: IData<IRemessa, IRemessaFilter>
    tableContainerProps?: TableContainerProps
    menu: IMenu
}

export function RemessaTable ({ isLoading, data, tableContainerProps, menu }: RemessaTableProps) {
    const formatter = useFormatter();
    const detalheModal = useModalWindow();

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="remessaId">ID</TableSortCell>
                        <TableSortCell fieldName="empresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="descricao">Descrição</TableSortCell>
                        <TableSortCell fieldName="geracao">Geração</TableSortCell>
                        <TableSortCell fieldName="competenciaGeracao">Competência</TableSortCell>
                        <TableSortCell fieldName="usuarioNome">Usuário</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((remessa, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{remessa.remessaId}</TableKeyCell>
                                    <TableCell>{remessa.empresaNome}</TableCell>
                                    <TableCell>{remessa.descricao}</TableCell>
                                    <TableCell>{formatter.toDate(remessa.geracao)}</TableCell>
                                    <TableCell>{remessa.competenciaGeracao}</TableCell>
                                    <TableCell>{remessa.usuarioNome}</TableCell>
                                    <TableCellAction onButtonClick={data.handleRowFocused(remessa, menu.open)} />
                                </TableRow>
                            )
                        })
                    }
                    <Pagination pagination={data.pagination} />
                </TableBody>
            </DataTable>

            {
                data.focusedRow !== undefined && (
                    <RemessaDetalheModal 
                        remessaId={data.focusedRow.remessaId}
                        modal={detalheModal}
                    />
                )
            }
        </React.Fragment>
    )
}